<template>
  <div class="image-container">
    <img :src="data.url" class="image-content" @click="setModal(true)"/>
    <div v-if="modalOpen" class="modal" @click="setModal(false)">
      <img class="modal-content" :src="data.url">
    </div>
  </div>
</template>

<script>
import { EventBus, Event } from '../../../util/event-bus'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      modalOpen: false
    }
  },
  methods: {
    setModal (status) {
      this.modalOpen = status
      EventBus.$emit(Event.IMAGE_EXPANDED, status)
    }
  }
}
</script>
